import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import StopFilledSvg from "@ant-design/icons-svg/es/asn/StopFilled";
import AntdIcon from "../components/AntdIcon";
var StopFilled = function StopFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: StopFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  StopFilled.displayName = 'StopFilled';
}
export default /*#__PURE__*/React.forwardRef(StopFilled);